import Link from '~/models/Link'
import { ApiLink } from '~/passporter-services/link/apiTypes'

export class LinkEntityMapper {
	static toLink = (link: ApiLink) => {
		const newLink = new Link({
			id: link.id,
			url: link.url,
			title: link.title,
			description: link.description,
			coverUrl: link.cover,
		})
		if (link.modified) newLink.modified = new Date(link.modified)
		return newLink
	}

	static toLinks = (links: ApiLink[]) => {
		return links.map((link: ApiLink) => this.toLink(link))
	}
}
